import { defineAction } from '~/prix'
import { z } from 'zod'
import communityGardenHarvestUpdateAction from './communityGardenHarvestUpdate.action.json' with { type: 'json' }
import { communityGardenHarvestObject } from '../../communityGardenHarvestObject'

const communityGardenHarvestUpdateDefinition = defineAction({
  ...communityGardenHarvestUpdateAction,

  input: communityGardenHarvestObject.pick({ id: true, type: true, quantity: true }),
  output: z.object({}),
})

export default communityGardenHarvestUpdateDefinition
